import EsusView from 'components/esus/EsusView'

export default function FichaElegibilidadeView() {
  return <EsusView url='/pec/user/cds/avaliacaoElegibilidadeAdmissao' />
}
